function forceUppercase(value) {
  return String(value || '').trim().toUpperCase();
}

function cleanEmail(value) {
  return String(value || '').trim().toLowerCase();
}

function cleanPhone(value) {
  return String(value || '').replace(/\D/g, '').replace(/^0+/, '').trim();
}

function buildFullPhone(countryCode, value) {
  const code = String(countryCode || '').replace(/\D/g, '');
  const raw = String(value || '').trim();
  let digits = raw.replace(/\D/g, '');
  if (!digits) return `+${code}`;
  if (raw.startsWith('+')) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.slice(2)}`;
  digits = digits.replace(/^0+/, '');
  if (code && digits.startsWith(code) && digits.length - code.length >= 8) return `+${digits}`;
  return `+${code}${digits}`;
}

export function buildLeadPayload(form, ctx = {}) {
  const finalPurpose = form.subject || ctx.purpose || '';
  const firstName = forceUppercase(form.name || form.firstName || '');
  const lastName = forceUppercase(form.lastName || '');
  const email = cleanEmail(form.email || '');
  const rawPhone = cleanPhone(form.phone || '');
  const countryCode = String(form.countryCode || '').trim();
  const fullPhone = buildFullPhone(countryCode, form.phone);
  const budgetRange = form.budgetRange || '';
  const budgetAmount = String(form.budgetAmount || '').trim();
  const budgetUnknown = !!form.budgetUnknown;

  let budget = '';
  if (budgetUnknown) {
    budget = 'Unknown';
  } else if (budgetRange && budgetAmount) {
    budget = `${budgetRange} | Exact: ${budgetAmount} ${form.currency || 'USD'}`;
  } else if (budgetRange) {
    budget = budgetRange;
  } else if (budgetAmount) {
    budget = `${budgetAmount} ${form.currency || 'USD'}`;
  }

  return {
    name: firstName,
    firstName,
    lastName,
    email,
    phone: fullPhone,
    countryCode,
    fullPhone,
    nationality: form.country || '',
    country: form.country || '',
    budget,
    budgetRange: budgetUnknown ? 'Unknown' : budgetRange,
    budgetAmount,
    budgetUnknown,
    currency: form.currency || 'USD',
    purpose: finalPurpose,
    subject: finalPurpose,
    financing: form.financing || '',
    timeline: form.timeline || '',
    listingType: form.listingType || ctx.listingType || '',
    budgetRangeLabel: budgetRange,
    exactBudget: budgetAmount,
    budgetAmount,
    budgetUnknown,
    currency: form.currency || 'USD',
    propertyId: ctx.propertyId || '',
    propertyTitle: ctx.title || ctx.propertyTitle || '',
    propertySlug: ctx.slug || ctx.propertySlug || '',
    leadSource: ctx.source || 'Site Web',
    sourcePage: ctx.sourcePage || ctx.source || '',
    sourceUrl: ctx.sourceUrl || (typeof window !== 'undefined' ? window.location.href : ''),
    sourceTitle: ctx.sourceTitle || ctx.title || ctx.propertyTitle || '',
    sourceCategory: ctx.sourceCategory || '',
    ctaMode: ctx.mode || 'contact',
    ctaKey: ctx.ctaKey || '',
    requestType: ctx.requestType || '',
    language: ctx.lang || 'En',
    lang: ctx.lang || 'En',
    notes: [
      ctx.title || ctx.propertyTitle || '',
      ctx.slug || ctx.propertySlug || '',
      ctx.lang || '',
      ctx.source || '',
      form.message || '',
      form.country ? `Country: ${form.country}` : '',
      form.listingType ? `Listing type: ${form.listingType}` : '',
      form.financing ? `Financing: ${form.financing}` : '',
      form.timeline ? `Timeline: ${form.timeline}` : '',
      budgetRange ? `Budget range: ${budgetRange}` : '',
      budgetAmount ? `Budget amount: ${budgetAmount} ${form.currency || 'USD'}` : '',
      budgetUnknown ? 'Budget unknown' : ''
    ].filter(Boolean).join(' | '),
    message: String(form.message || '').trim()
  };
}
